export const drawerStyles = {
  components: {
    Drawer: {
      // 3. We can add a new visual variant
      variants: {
        "with-shadow": {
          placement: "right",
          boxShadow: "0 0 2px 2px #efdfde",
          bgColor: "red",
        },
      },
      baseStyle: {
        overlay: {
          transition: "opacity 0.2s ease-linear 0.05s",
        },
        dialogContainer: {
          transition: "transform 0.2s ease-linear 0.05s, opacity 0.2s ease-linear 0.05s",
        },
        dialog: {
          transition: "transform 0.2s ease-linear 0.05s, opacity 0.2s ease-linear 0.05s",
        },
      },
    },
  },
};

